module.exports = __webpack_public_path__ + "static/img-2b1d41397299726a6e52fb3fd4875fa3.jpg";